(() => {
    angular
        .module('app')
        .controller('host.views.panelRecruitment.index', PanelRecruitmentController);

    function PanelRecruitmentController() {
        const vm = this;

        vm.permissions = getPermissions();

        function getPermissions() {
            return {
                canViewDashboard: abp.auth.isGranted('PanelRequests.Host.RecruitmentDashboard')
            };
        }
    }
})();
